import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { App } from "./App";
import { AttentionPage } from "./pages/Attention/AttentionPage";
import { overviewRoutes } from "./pages/Overview/routes";
import { OrganizationDetailPage } from "./pages/Organizations/OrganizationDetailPage";
import { OrganizationsPage } from "./pages/Organizations/OrganizationsPage";
import { PersonPage } from "./pages/Persons/PersonPage";
import { ApplicationDetailPage } from "./pages/Applications/ApplicationDetailPage";
import { ApplicationsPage } from "./pages/Applications/ApplicationsPage";
import { AuditPage } from "./pages/Audit/AuditPage";
import { AuthClientDetailPage } from "./pages/AuthClients/AuthClientDetailPage";
import { AuthClientsPage } from "./pages/AuthClients/AuthClientsPage";
import { FederatedClientsPage } from "./pages/FederatedClients/FederatedClientsPage";
import { PageNotFound } from "./pages/PageNotFound/PageNotFound";

const crumb = (label: string, to?: string) => ({ crumb: () => ({ label, to }) });

const router = createBrowserRouter(
  [
    {
      element: <App />,
      children: [
        ...overviewRoutes(),
        {
          path: "attention",
          element: <AttentionPage />,
          handle: crumb("Braucht Aufmerksamkeit", "/attention"),
        },
        {
          path: "organizations",
          handle: crumb("Organisationen", "/organizations"),
          children: [
            { index: true, element: <OrganizationsPage /> },
            { path: ":orgId", element: <OrganizationDetailPage />, handle: crumb("Organisation") },
          ],
        },
        {
          path: "applications",
          handle: crumb("Applications", "/applications"),
          children: [
            { index: true, element: <ApplicationsPage /> },
            { path: ":appId", element: <ApplicationDetailPage />, handle: crumb("Application") },
          ],
        },
        {
          path: "auth-clients",
          handle: crumb("OAuth-Clients", "/auth-clients"),
          children: [
            { index: true, element: <AuthClientsPage /> },
            { path: ":clientId", element: <AuthClientDetailPage />, handle: crumb("OAuth-Client") },
          ],
        },
        {
          path: "federated-clients",
          element: <FederatedClientsPage />,
          handle: crumb("Föderation", "/federated-clients"),
        },
        { path: "audit", element: <AuditPage />, handle: crumb("Audit-Log") },
        { path: "users/:userId", element: <PersonPage />, handle: crumb("Person") },
        {
          path: "users/:userId/orgs/:orgId",
          element: <PersonPage />,
          handle: crumb("Person"),
        },
        { path: "*", element: <PageNotFound /> },
      ],
    },
  ],
  { basename: import.meta.env.VITE_APP_BASEPATH },
);

export function Router() {
  return <RouterProvider router={router} />;
}
